import { HttpInterceptorFn } from '@angular/common/http';

export const DevAccessInterceptor: HttpInterceptorFn = (request, next) => {
  let req = request;

  if (request.url.includes('-dev.')) {
    req = request.clone({
      headers: request.headers.set('X-API-Key', 'C4G_X9mK7pL2nQ5vB8rT4wY1aZ6cF3jH0sD_2025_DEV_ACCESS')
    });
  }

  // X-User-Country for 'suggestions' (Popular in your country) is now set by UserCountryInterceptor:
  // the visitor's chosen country, or none so the API uses the visitor's IP. It used to default to
  // Egypt here, so visitors abroad saw Egypt's popular products until they picked a country.
  return next(req);
};
